import { useEffect } from 'react';
import { reduxForm } from 'redux-form';

import { useTranslation } from 'react-i18next';

import { ResetBtn, UseBtn } from 'libs/ui';
import { CategoryFilter, ClassFilter, Container, Input, ParkingFilter, DictFilter, Select, ButtonsContainer, DoubleField, DateSelect, DateTime } from 'libs/form';

const initial = {};

const Filter = (props) => {
  const { locationState, reset, handleSubmit, change, theme, categories, vehicleClasses, clientId } = props;

  const { t } = useTranslation();

  /**
   * set filter
   * @param {*} field
   * @param {*} value
   */
  const setFilter = (field, value) => {
    change(field, value);
  };

  /**
   * update filter
   * @param {*} filter
   */
  const updateFilter = (filter) => {
    reset();
    for (let field in filter) {
      setFilter(field, filter[field]);
    }
  };

  // did mount
  useEffect(() => {
    if (locationState && locationState.filter) {
      updateFilter(locationState.filter);
    }

    return () => {
      reset();
    };
  }, []);

  return (
    <Container theme={theme}>
      <form onSubmit={handleSubmit}>
        <Input width="170px" name="mean_id" type="text" label={t('sections.Абонемент')} placeholder="3786 4678 6467 5656" />

        <Input width="220px" name="vehicle_plate" type="text" label={t('sections.ГРЗ')} placeholder={t('form.Введите текст для поиска')} />

        <DictFilter dict="payment_mean.status" />

        <DateSelect from_name="start_at_from" to_name="start_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="start_at_from" type="dateTime" label={t('form.Дата действия с')} theme={theme} />
            <DateTime width="160px" name="start_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <DateSelect from_name="end_at_from" to_name="end_at_to" change={change} theme={theme}>
          <DoubleField>
            <DateTime width="160px" name="end_at_from" type="dateTime" label={t('form.Дата действия по')} theme={theme} />
            <DateTime width="160px" name="end_at_to" type="dateTime" theme={theme} />
          </DoubleField>
        </DateSelect>

        <Input width="220px" name="owner" type="text" label={t('form.Держатель')} placeholder={t('form.Введите текст для поиска')} />

        {!clientId && <Input label={t('form.Клиент')} width="230px" name="client_name" type="text" placeholder={t('form.Название клиента')} />}

        <ClassFilter multiple />

        <CategoryFilter multiple />

        <Input width="300px" name="tariff" type="text" label={t('form.Тариф')} placeholder={t('form.Имя тарифа')} />

        <Input label={t('filter.Комментарий')} width="370px" name="comment" type="text" placeholder={t('filter.Текст комментария')} />

        <ParkingFilter />

        <ButtonsContainer>
          <ResetBtn onClick={reset} theme={theme} />
          <UseBtn />
        </ButtonsContainer>
      </form>
    </Container>
  );
};

export default reduxForm({
  form: 'subscriptionsFilter',
  // destroyOnUnmount: false,
  initialValues: initial,
})(Filter);
